import { TimePicker } from "antd";
import React from "react";
import { Form } from "../../atoms";
const format = "HH:mm";
interface IInputNumberFieldProps {
  label: string | React.ReactElement;
  rules?: any[];
  name: string | any[];
  placeholder?: string;
  style?: any;
  initialValue?: any;
  className?: string;
  bordered?: boolean;
  minuteStep?: number;
}

export const InputTimeField: React.FC<IInputNumberFieldProps> = ({
  label,
  rules,
  name,
  placeholder,
  style,
  className,
  initialValue,
  bordered = true,
  minuteStep = 5,
}) => (
  <Form.Item
    label={label}
    name={name}
    rules={rules}
    className={className}
    initialValue={initialValue}
    style={style}
  >
    <TimePicker
      placeholder={placeholder}
      bordered={bordered}
      style={style}
      format={format}
      minuteStep={minuteStep}
    />
  </Form.Item>
);
